const InButtonSpinner = (props: { apiCall: boolean }) => {
  if (!props.apiCall) {
    return <></>
  }
  return <span className="spinner-border animate-spin inline-block w-4 h-4 border-4 rounded-full ml-2" role="status"></span>
}

export default InButtonSpinner;